import { cn } from '@nextui-org/react'
import React from 'react'
import { Typography } from '../common/Typography'

export interface TabItemProps {
  text: string
  icon: React.ReactNode
  active?: boolean
  disabled?: boolean
  className?: string
  onClick?: () => void
  onContextMenu?: (e: React.MouseEvent) => void
}

export const TabItem: React.FC<TabItemProps> = ({
  text,
  icon,
  active = false,
  disabled = false,
  className,
  onClick,
  onContextMenu,
  ...props
}) => {
  const baseClasses = [
    'box-border',
    'content-stretch',
    'flex',
    'flex-row',
    'items-center',
    'justify-center',
    'relative',
    'rounded-full',
    'shrink-0',
    'transition-all',
    'duration-200',
    'cursor-pointer',
    'gap-x-3',
    'active:bg-tokens-primary-2 active:text-tokens-neutral-text-white active:border-tokens-primary-2',
    'px-5 py-2',
    'select-none'
  ]

  const stateClasses = [
    'border',
    disabled
      ? 'text-tokens-neutral-text-secondary border-tokens-neutral-border-1 cursor-not-allowed'
      : active
        ? 'bg-tokens-primary-2 text-tokens-neutral-text-white border-tokens-primary-2'
        : 'text-tokens-neutral-text-secondary border-tokens-neutral-border-1 hover:bg-tokens-primary-2 hover:text-tokens-neutral-text-white hover:border-tokens-primary-2'
  ]

  return (
    <div
      className={cn(...baseClasses, ...stateClasses, className)}
      role='tab'
      aria-selected={active}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      onClick={!disabled ? onClick : undefined}
      onContextMenu={!disabled ? onContextMenu : undefined}
      {...props}
    >
      {icon && <div className='relative shrink-0 size-4 text-current'>{icon}</div>}
      <Typography
        fontFamily='geist'
        fontSize='bodyMd'
        fontWeight='medium'
        style={{ color: 'inherit', whiteSpace: 'pre' }}
      >
        {text}
      </Typography>
    </div>
  )
}

export default TabItem
